import styled from "@emotion/styled";
import { HEADING } from "src/constants/colors";

export const Container = styled.div`
  border-radius: 16px;
  border: 1px solid #bdd0ff;
  background: #e7eeff;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
`;

export const HeaderRow = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 14px 16px;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HeaderTitle = styled.div`
  color: ${HEADING};
  font-size: 16px;
`;

export const HeaderSubtitle = styled.div`
  font-size: 12px;
`;

export const IconWrapper = styled.div`
  background-color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 36px;
`;

export const AvailableLenderRow = styled.div`
  background-color: rgb(255, 255, 255);
  border: 2px solid rgba(64, 117, 255, 1);
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  height: 34px;
  padding: 12px 16px;
  box-sizing: content-box;
`;

export const LenderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const Monogram = styled.div`
  background-color: rgba(229, 235, 253, 1);
  border-radius: 50%;
  color: rgba(20, 83, 245, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  height: 24px;
  text-transform: capitalize;
  width: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const ActionsWrapper = styled.div<{ visible: boolean }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${({ visible }) => (visible ? "auto" : "none")};
`;
